import { createSelector } from 'reselect';
import { getPrice, getHaFee } from '../reducer';

const getTotal = createSelector(
  [getPrice, getHaFee],
  (price, fee) => price + fee,
);

export { getTotal };
